//时间格式化处理
function dateFtt(fmt,date) {

    var o = {
        "M+" : date.getMonth()+1,                 //月份
        "d+" : date.getDate(),                    //日
        "h+" : date.getHours(),                   //小时
        "m+" : date.getMinutes(),                 //分
        "s+" : date.getSeconds(),                 //秒
        "q+" : Math.floor((date.getMonth()+3)/3), //季度
        "S"  : date.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt))
        fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(var k in o)
        if(new RegExp("("+ k +")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
}


//获取当时时候
function getNowFormatDate() {

    var date = new Date();
    return dateFtt("yyyy-MM-dd hh:mm:ss",date);
}


function getNowDateTime() {

    var date = new Date();
    return dateFtt("yyyy-MM-dd hh:mm:ss",date);
}


function getNowDate() {

    var date = new Date();
    return dateFtt("yyyy-MM-dd",date);
}

function getNowMonth() {

    var date = new Date();
    return date.getMonth() + 1;
}

function getNowYear() {

    var date = new Date();
    return date.getFullYear();
}



//java日期转js日期
function getJsDate(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("yyyy-MM-dd",date);
    }
}


//java日期转js日期+时间
function getJsDateTime(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("yyyy-MM-dd hh:mm:ss",date);
    }
}

function getJsYearMonth(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("yyyy-MM",date);
    }
}

function getJsMonthDay(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("MM-dd",date);
    }
}


function getJsYear(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("yyyy",date);
    }
}

function getJsMonth(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("MM",date);
    }
}

function getJsDay(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("dd",date);
    }
}

//指定日期增加指定天数
function getAddDays(dateStr, days) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        date.setDate(date.getDate()+ days);
        return dateFtt("yyyy-MM-dd",date);
    }
}

//指定日期转时间搓
function getUnixTime(dateStr)
{
    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var newstr = dateStr.replace(/-/g,'/');
        var date =  new Date(newstr);
        var time_str = date.getTime().toString();
        return time_str.substr(0, 10)+"000";
    }
}



//根据指定日期格式化输出 刚刚，几分钟前，几小时前，今天，其他日期
function getDateStr(stringTime) {
    let str = stringTime;
    //将字符串转换成时间格式
    let timePublish = new Date(str);
    let timeNow = new Date();

    let timePublish1 = new Date(getJsDate(str));
    let timeNow1 = new Date(getNowDate());

    let minute = 1000 * 60;
    let hour = minute * 60;
    let day = hour * 24;
    let month = day * 30;
    let year = month * 12;
    let diffValue = timeNow - timePublish;
    let diffValue1 = timeNow1 - timePublish1;

    //let diffMonth = diffValue / month;
    //let diffWeek = diffValue / (7 * day);
    let diffDay = diffValue1 / day;
    let diffHour = diffValue / hour;
    let diffMinute = diffValue / minute;

    //let diffYear = diffValue / year;
    let result = null
    if ((diffValue > 0) && (diffMinute < 1) ) {
        result = "刚刚";
    } else if (diffHour > 1 && diffHour < 3) {
        result = parseInt(diffHour) + "小时前";
    } else if (diffMinute >= 1 && diffMinute < 60 ) {
        result = parseInt(diffMinute) + "分钟前";
    } else if (diffHour >= 3 && diffDay < 1) {
        result = "今天";
    } else {
        result = getJsDateTime(stringTime);
    }
    return result;
 }

 function getWeekday(date) {
    const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    const weekday = new Date(date).getDay();
    return weekdays[weekday];
}

function getMonthAllDays() {
    // 获取当前日期
    var currentDate = new Date();       
    // 获取当前月份的第一天
    var firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);          
    // 获取当前月份的最后一天
    var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);          
    // 遍历当月的所有日期
    let result = "";
    for (var date = firstDayOfMonth; date <= lastDayOfMonth; date.setDate(date.getDate() + 1)) {
      result = result + '<p>' + getJsMonthDayCh(date) + " " + getWeekday(date) +  '</p>'
      console.log(date.getDate());
    }
    return result;
}

function getJsMonthDayCh(dateStr) {

    if ((dateStr == null) ||(dateStr == ""))
    {
        return "";
    } else {
        var date = new Date(dateStr);
        return dateFtt("MM月dd日",date);
    }
}



export  {
    getNowFormatDate, getNowDateTime,getNowDate,getNowMonth,getNowYear,getJsDate,getJsDateTime,getJsYear,getJsMonth,getJsDay,getJsYearMonth,
    getAddDays,getUnixTime,getJsMonthDay,getDateStr,getWeekday,getMonthAllDays,getJsMonthDayCh
}




// WEBPACK FOOTER //
// ./src/utils/dateUtils.js